export default __webpack_public_path__ + "static/media/logo-full.5dd3b3fc.svg";